module.exports = __webpack_public_path__ + "assets/img/cross.c4b9911e.svg";